import { render, staticRenderFns } from "./GestionProfesiones.vue?vue&type=template&id=2c204959"
import script from "./GestionProfesiones.vue?vue&type=script&lang=js"
export * from "./GestionProfesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports